/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Border_Style_AriaInputs */



/**
* | output |
* | --- |
* | "Border Style" |
*
* @param {Video_Export_Border_Style_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_border_style_aria = /** @type {((inputs?: Video_Export_Border_Style_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Border_Style_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style de bordure")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rahmenstil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile del bordo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стиль границы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo de borde")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("边框样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("境界線のスタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बॉर्डर शैली")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilo de borda")
	return /** @type {LocalizedString} */ ("Border Style")
});